"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

var _theme = _interopRequireDefault(require("./theme.js"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var _default = {
  all: function all() {
    return _styledComponents.css.apply(void 0, arguments);
  },
  small: function small() {
    return (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    @media (max-width: ", "px) {\n      ", ";\n    }\n  "])), _theme["default"].breakpoints.values.md, _styledComponents.css.apply(void 0, arguments));
  },
  gtSmall: function gtSmall() {
    return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "])), _theme["default"].breakpoints.values.md + 1, _styledComponents.css.apply(void 0, arguments));
  },
  medium: function medium() {
    return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    @media (min-width: ", "px and max-width ", "px) {\n      ", "\n    }\n  "])), _theme["default"].breakpoints.values.md + 1, _theme["default"].breakpoints.values.lg, _styledComponents.css.apply(void 0, arguments));
  },
  gtMedium: function gtMedium() {
    return (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "])), _theme["default"].breakpoints.values.md + 1, _styledComponents.css.apply(void 0, arguments));
  },
  large: function large() {
    return (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "])), _theme["default"].breakpoints.values.lg + 1, _styledComponents.css.apply(void 0, arguments));
  },
  gtLarge: function gtLarge() {
    return (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "])), _theme["default"].breakpoints.values.lg + 1, _styledComponents.css.apply(void 0, arguments));
  }
};
exports["default"] = _default;